<template>
    <div >
      <MdTitle v-bind:Text="$t('Shared.LogNotesTitle')" />
      <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="LoadLogNotes"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="LoadLogNotes">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'LogNotesFiltersRepDateFrom'"
              :Type="'date'" 
              :OnPressEnter="LoadLogNotes"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'LogNotesFiltersRepDateTo'"
              :Type="'date'" 
              :OnPressEnter="LoadLogNotes"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateToValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:Model="PatientCodeModel"
              v-bind:FieldDescription="'patientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
          
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.NoteType')"
              v-bind:Options="NoteTypesList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'notesId'"
              v-bind:Model="ModelNoteType"
              v-bind:Multiple="false"              
              :Input="ChangeDropDownNodeType"
              v-bind:Name="'note_type_select'"
              v-bind:isRequired="true"
              v-bind:isValid="this.isNoValid"
            />
          </b-col>
           <b-col lg="3" md="3" sm="12">
              <MdSelect
                  v-bind:Label="$tc('Shared.Employee',2)"
                  v-bind:Options="EmployeesList"
                  v-bind:Model="VmodelEmployees"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'code'"
                  v-bind:Multiple="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownEmployees"
                  :CustomLabel="customLabelEmployee"/>
            </b-col>
          <b-col lg="6" md="6" sm="12"></b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadLogNotes"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('Shared.LogNotesTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportLogNotesFilters"
          :ReportName="'LogNotes'"
          :ReportTitle="$t('Shared.LogNotesTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('Shared.LogNotesTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/MedicalSignNotes/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import PatientService from '@/services/patient.service'
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import Utils from '../../../common/utils'
  import { EventBus } from '@/event-bus.js';
  import BioSetupService from '@/services/biosetup.service'
  import MedicalSignNotesService from "@/services/medicalsignnotes.service";
  import GlobalService from '@/services/global.service'
  import UserPreference from "@/services/quickhelp.service"; 
  import LocalStorage from '@/services/storage.service';

  export default Vue.extend({
      name: "logNotesFiltersRep",
      mixins: [ ShowMessage, DBFunctions ],
      components: { DxPopup },
      data() {
          return {
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              PatientsList:[],
              PatientCodeModel:'',
              EmployeesList:[],
              VmodelEmployees:"",
              dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0 ,
                NotesID:null     
              },
              params: {
                PatientCodeList: '',
                NotesID: '',
                EmployeesList:''
              },
              items: [],         
              fields: [
              { key: 'comments', sortable: true, label: this.$tc('Shared.Note', 2), class: 'text-wrap', generated:false },
                { key: 'intakeDate', sortable: true, label: 'Intake Date', class: 'hidden', generated:false},
                { key: 'employeeId', sortable: true, label: 'employeeId', class: 'hidden', generated:false},
                { key: 'employeeName', sortable: true, label: this.$tc('Shared.Employee'), class: '', generated:false}, 
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['dateFrom','dateTo'] ,
              NoteTypesList: [],
              ModelNoteType: null,
              NotesTitlesParams:{
                SearchCriteria: '',
                PageNumber : 0,
                PageSize: 0,
                NoteTypeList: ['TFrmMdLogNotes', 'TFRMMDMEDICALSIGNSNOTES'],
                Active:true
              },
              isNoValid: true,
              UserId: LocalStorage.getUserId(),
              isDateFromValid: true,
              isDateToValid: true,  
            }
      },
      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

      
          ChangeDropDownPatients(values) {
            this.params.PatientCodeList = [];
            values.forEach(it => {
              this.params.PatientCodeList.push(it.patientcode)
            });
          },

          customLabelPatients ({ PatientName, patientcode }) {
            return `${PatientName} – ${patientcode}`
          },
          
          ChangeDropDownEmployees(values) {
            this.params.EmployeesList = [];
            values.forEach(it => {
              this.params.EmployeesList.push(it.code)
            });
          },

          customLabelEmployee ({ name, code }) {
            return `${name} – ${code}`
          },

          async getPatients() { 
            await PatientService.getPatientList(this.parameter)
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.PatientsList = response.data;
                this.PatientsList.forEach(function(element) {
                  element.PatientName = element.firstname + " " + element.lastname;   
                });
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
          },

          async getEmployees(){
            await GlobalService.getEmployeeActive()
              .then((response) => {
                  if(response.status == '200'){
                      this.EmployeesList = response.data; 
                  }                             
              })
              .catch((error) => {
                  if (error.response) {
                      this.showMessage(this.$tc('Msg.Error'),error,"error");
                  }
              });
          },

          onClickClose() {
            // this.isParamVisible = false;
          },

          ChangeDropDownNodeType(value) {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;

            this.DeleteDinamicField();
            this.params.NotesID = this.ModelNoteType = value ? value.notesId : '';
          },

          generateFields(item){
             // Limpiar campos dinámicos pero mantener actions
            this.DeleteDinamicField();
            // Agregar la columna Date si no existe
            const hasDate = this.fields.some(f => f.key === 'intakeDateFormatted');
            if (!hasDate) {
              this.fields.splice(0, 0, { key: 'intakeDateFormatted', sortable: true, label: this.$t('Shared.Date'), class: '', generated: false });
            }
            
            // Agregar campos dinámicos
            let arrfields = item.fields;
            let reverse = arrfields.slice().reverse();    
            reverse.forEach(fitem => {  
              // Verificar si el campo ya existe para evitar duplicados
              const exists = this.fields.some(f => f.key === fitem.description);
              if (!exists) {
                // Insertar después de la columna Date (índice 1) pero antes de otros campos dinámicos
                const insertIndex = 1; 
                this.fields.splice(insertIndex, 0, { 
                  key: fitem.code, 
                  sortable: true, 
                  label: fitem.description, 
                  class: 'text-wrap', 
                  generated: true 
                });
              }
            });
            
            this.OnSetField();
          },

          OnSetField(){
            EventBus.$emit('onSetField', this.fields);   
          },

          DeleteDinamicField(){
            var arr = this.fields;
            let temp = [];
           
            arr.forEach(item => {        
              if(!item.generated){
                temp.push(item);
              }
            });

            this.fields = temp;
            this.OnSetField(); 
          },

          PopulateItems(arr){     
            this.items = [];
            arr.forEach(item => {
              let obj = {}      
              // Campos fijos
              obj['intakeDate'] = Utils.formatterDateTimeAndSecondsToString(item['intakeDate']);
              obj['intakeDateFormatted'] = Utils.formatterDateTimeToString(item['intakeDateFormatted']);
              obj['employeeName'] = item['employeeName'];       
              obj['employeeId'] = item['employeeId'];  
              obj['comments'] = item['comments'];
              
              // Campos dinámicos - usar code como key
              let fields = item['fields'];
              if (fields && fields.length > 0) {
                fields.forEach(f => {
                  obj[f.code] = f.intakeValue;  // Usar code como key
                });
              }
              
              this.items.push(obj)
            });
            console.log('PopulateItems - items:', this.items); // Debug
          },
       
          async getNotesTitles() {
            await BioSetupService.getAll(this.NotesTitlesParams, true)
              .then((response) => {
                if (response.status == "200" && response.data && response.data.length > 0) {
                  this.NoteTypesList = response.data;
                }
              })
              .catch((error) => {
                  this.showResponseErrorMessage(error);
              });
          },
          
          reportList() {
              this.checkExistFavorite('/app/reports/notes');
              this.$router.push({ name: "reportListNotes" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []

            this.reportParams.push({ paramName: 'startDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'endDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'patientCode', paramValue: this.params.PatientCodeList })
            this.reportParams.push({ paramName: 'employeeCode', paramValue: this.params.EmployeesList})
            this.reportParams.push({ paramName: 'intakeDate', paramValue: null})
            // this.reportParams.push({ paramName: 'headerID', paramValue: this.headerID})
            this.reportParams.push({ paramName: 'notesID', paramValue: this.params.NotesID})
            this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
          },

          onClickShowReport() {
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportLogNotesFilters.buildDocument(this.reportParams)
          },

          LoadLogNotes() {
            if (!this.validateForm()) return;

            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
            // Asignaciones condicionales
            this.parameter.patientCode = this.params.PatientCodeList && this.params.PatientCodeList !== '' 
                ? this.params.PatientCodeList 
                : null;
            this.parameter.employeeCode = this.params.EmployeesList && this.params.EmployeesList !== '' 
                ? this.params.EmployeesList 
                : null;
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
            this.parameter.NotesID = this.params.NotesID;
          },

          async getListing() { 
             
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.initializeParameters();
         
            await MedicalSignNotesService.getAll(this.parameter, true)
              .then((response) => {
                if (response.status == "200" && response.data && response.data.length > 0) {           
                  let headerString = response.headers["x-pagination"];
                  this.Header = JSON.parse(headerString);
                  this.totalRows = this.Header.TotalCount;
                  this.ShowMessageIsEmpty = response.data && response.data.length == 0 ? true : false;
                  this.generateFields(response.data[0]);
                  this.PopulateItems(response.data);          
                }else{
                  this.items = [];          
                  this.DeleteDinamicField();
                  this.totalRows = 0;
                  this.currentPage = 1;
                  this.ShowMessageIsEmpty = true;          
                }
              })
              .catch((error) => {
                  this.showResponseErrorMessage(error);
              });
         
          },

          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('LogNotes', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('LogNotes', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          validateForm() {
            // Primera validación
            this.isNoValid = !!(this.ModelNoteType && this.ModelNoteType.length);
            
            // Segunda validación
            const isValid = this.validate_date_range();
            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;
            
            this.$forceUpdate();
            
            if (!isValid) {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
              return false;
            }
            return this.isNoValid;
          },

          async getUserPreference() {
            await UserPreference.getQhUserPreference(this.UserId)
              .then((response) => {
                if (response.data && response.data.length > 0) {
                  let LastLogNote = response.data[0].lastLogNote ;
                  LastLogNote = LastLogNote == null ? '' : LastLogNote
                  if (LastLogNote) {
                    this.ModelNoteType = this.findNoteTypeName(this.NoteTypesList, LastLogNote).notesId;
                    this.params.NotesID = this.ModelNoteType;
                  }
                } 
              })
              .catch((error) => {
                this.showResponseErrorMessage(error);
              });
          },

          findNoteTypeName (array, code) {
            return array.find(element => element.notesId === code) ?? -1;
          },

          validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
          },
      },
      
      async mounted() {
        await this.getPatients();
        await this.getNotesTitles();
        await this.getEmployees();
        await this.getUserPreference()
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
